import { THEME } from "../theming/theming";
export const EXTRA_SMALL_BREAK = `@media screen and (max-width: ${THEME.breakpoints.small - 1}px)`;
export const SMALL_BREAK = `@media screen and (min-width: ${THEME.breakpoints.small}px)`;
export const MEDUIM_BREAK = `@media screen and (min-width: ${THEME.breakpoints.medium}px)`;
export const LARGE_BREAK = `@media screen and (min-width: ${THEME.breakpoints.large}px)`;
